module.exports = __webpack_public_path__ + "static/media/Fontys Logo.e9b8bab3.jpg";